import Cleave from 'cleave.js'

export default (phone, countryIsoCode = 'AR') => {
  const el = document.createElement('input')
  el.value = phone
  el.setAttribute('readonly', '')
  const $el = 'phone_' + Date.now()
  el.setAttribute('id', $el)
  el.style.position = 'absolute'
  el.style.left = '-1000em'
  document.body.appendChild(el)

  const retPhone = (new Cleave('#' + $el, { phone: true, phoneRegionCode: countryIsoCode.toLowerCase() })).properties.result

  el.remove()

  return phone.length > retPhone.length ? phone : retPhone
}
